import React, { useEffect, useState } from "react";
import { Button, Col, Container, Offcanvas, Row } from "react-bootstrap";
import { Images } from "./Images";
import { NavLink } from "react-router-dom";
import Marque from "./Marque";

const Banner = ({ cmsLits }) => {
  console.log("🚀 ~ Banner ~ cmsLits:", cmsLits)
  const [value1, setValue1] = useState()
  const [value2, setvalue2] = useState()
  const [value3, setvalue3] = useState()
  const [value4, setvalue4] = useState()

  // let value1
  // let value2
  // let value3
  // let value4

  useEffect(() => {
    if (cmsLits) {
      setValue1(cmsLits.find((value) => (value.identifier == 'Home Main')))
      setvalue2(cmsLits.find((value) => (value.identifier == 'Home Value1')))
      setvalue3(cmsLits.find((value) => (value.identifier == 'Home Value2')))
      setvalue4(cmsLits.find((value) => (value.identifier == 'Home Value3')))
    }
  }, [cmsLits]);
  return (
    <div className="banner h-auto">
      <Container className="w-100 h-100 custom_container">
        <div className="banner_content w-100 h-100">
          <div className="center_cnt">
            <h3 className="mb-0 title-txt hacked-font title_txttwo">
              {value1?.heading}
            </h3>
            <p className="subTitle-txt mb-0 auttera-font">
              {value1?.content}

            </p>
            <div className="btn-sec">
              <Button className="get_started_btn cmn_blueBtn imgbtn hacked-font">
                Get Started
              </Button>
            </div>
            {/* <div className="users_percent">
              <div className="items text-center">
                <p className="mb-0 value">{value2?.content}</p>
                <p className="mb-0 label">{value2?.heading}</p>
              </div>
              <div className="items text-center">
                <p className="mb-0 value">{value3?.content}</p>
                <p className="mb-0 label">{value3?.heading}</p>
              </div>
              <div className="items text-center">
                <p className="mb-0 value">{value4?.content}</p>
                <p className="mb-0 label">{value4?.heading}</p>
              </div>
            </div> */}
          </div>
        </div>
      </Container>
      {/* <Marque /> */}
      <img src={Images.bannertext} alt="Sector 8" className="img-fluid bannertextimg" />
    </div>
  );
};

export default Banner;
